import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {Container} from "@pg-design/grid-module";
import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    h100,
    onDesktop,
    p,
    resetWidth,
    w50,
    w100
} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

export const CreditCalculatorInfo = () => {
    const theme = useTheme();

    return (
        <Container fluid css={backgroundColor(theme.colors.gray[200])}>
            <Container css={infoSectionStyle}>
                <div css={contentPositioner}>
                    <div css={boxesWrapper}>
                        <div css={[boxStyle, backgroundColor(theme.colors.info)]}>
                            <Text variant="headline_3" align="center">
                                Zdolność kredytowa
                            </Text>
                            <Text variant="body_copy_0" align="center" css={bodyCopy}>
                                Zdolność kredytowa wskazuje, na jakie maksymalne finansowanie możesz liczyć, a <strong>kalkulator zdolności kredytowej</strong>{" "}
                                w kilku krokach pomoże Ci oszacować Twoje możliwości. To narzędzie pomoże Ci lepiej zrozumieć, jakie opcje są dostępne przy
                                planowaniu zakupu mieszkania.
                            </Text>
                            <Button
                                href={rpAppLink.credits.rating()}
                                css={buttonStyle}
                                variant="filled_primary"
                                dataTestId={CREDIT_PAGES_IDS.MAIN_PAGE.CHECK_CREDITWORTHINESS_BUTTON}
                            >
                                Sprawdź zdolność kredytową
                            </Button>
                        </div>

                        <div css={[boxStyle, backgroundColor(theme.colors.success)]}>
                            <Text variant="headline_3" align="center">
                                Rata kredytu
                            </Text>
                            <Text variant="body_copy_0" align="center" css={bodyCopy}>
                                Nasza <strong> porównywarka ofert kredytowych</strong> umożliwi Ci łatwe zestawienie różnych propozycji, co pozwoli na lepsze
                                zrozumienie, jakie zobowiązania miesięczne będą Cię czekały. Dzięki temu narzędziu będziesz mógł ocenić, która oferta najlepiej
                                odpowiada Twoim potrzebom i możliwościom finansowym.
                            </Text>
                            <Button
                                href={rpAppLink.credits.offers()}
                                css={buttonStyle}
                                variant="filled_primary"
                                dataTestId={CREDIT_PAGES_IDS.MAIN_PAGE.COMPARE_CREDITS_OFFERS_BUTTON}
                            >
                                Porównaj oferty kredytowe
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>
    );
};

const bodyCopy = css`
    margin: 4rem 0;
    ${onDesktop(css`
        margin: 0;
    `)};
`;

const infoSectionStyle = css`
    margin-bottom: 0;

    ${onDesktop(css`
        margin: 65px auto -110px auto;
    `)};
`;

const contentPositioner = (theme: Theme) => css`
    ${w100};
    ${h100};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(8)};
    transform: translateY(-15%);

    @media (min-width: ${theme.breakpoints.md}) {
        transform: translateY(-40%);
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        gap: ${calculateRemSize(10)};
        transform: translateY(-50%);
    }
`;

const boxesWrapper = css`
    ${w100};
    gap: ${calculateRemSize(2)};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};

    ${onDesktop(css`
        gap: ${calculateRemSize(4)};
        ${flexDirection("row")};
    `)};
`;

const boxStyle = (theme: Theme) => css`
    ${w100};
    ${borderRadius(2)};
    ${elevation(2)};
    ${flex("center", "space-around")};
    ${p(3, 1)};
    ${flexDirection("column")};

    @media (min-width: ${theme.breakpoints.md}) {
        ${w50};
        ${p(3, 8)};
        height: 450px;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
        height: 368px;
    }
`;

const buttonStyle = (theme: Theme) => css`
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${resetWidth}
    }
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {Container} from "@pg-design/grid-module";
import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    h100,
    onDesktop,
    p,
    resetWidth,
    w50,
    w100
} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

export const CreditCalculatorInfo = () => {
    const theme = useTheme();

    return (
        <Container fluid css={backgroundColor(theme.colors.gray[200])}>
            <Container css={infoSectionStyle}>
                <div css={contentPositioner}>
                    <div css={boxesWrapper}>
                        <div css={[boxStyle, backgroundColor(theme.colors.info)]}>
                            <Text variant="headline_3" align="center">
                                Zdolność kredytowa
                            </Text>
                            <Text variant="body_copy_0" align="center" css={bodyCopy}>
                                Zdolność kredytowa wskazuje, na jakie maksymalne finansowanie możesz liczyć, a <strong>kalkulator zdolności kredytowej</strong>{" "}
                                w kilku krokach pomoże Ci oszacować Twoje możliwości. To narzędzie pomoże Ci lepiej zrozumieć, jakie opcje są dostępne przy
                                planowaniu zakupu mieszkania.
                            </Text>
                            <Button
                                href={rpAppLink.credits.rating()}
                                css={buttonStyle}
                                variant="filled_primary"
                                dataTestId={CREDIT_PAGES_IDS.MAIN_PAGE.CHECK_CREDITWORTHINESS_BUTTON}
                            >
                                Sprawdź zdolność kredytową
                            </Button>
                        </div>

                        <div css={[boxStyle, backgroundColor(theme.colors.success)]}>
                            <Text variant="headline_3" align="center">
                                Rata kredytu
                            </Text>
                            <Text variant="body_copy_0" align="center" css={bodyCopy}>
                                Nasza <strong> porównywarka ofert kredytowych</strong> umożliwi Ci łatwe zestawienie różnych propozycji, co pozwoli na lepsze
                                zrozumienie, jakie zobowiązania miesięczne będą Cię czekały. Dzięki temu narzędziu będziesz mógł ocenić, która oferta najlepiej
                                odpowiada Twoim potrzebom i możliwościom finansowym.
                            </Text>
                            <Button
                                href={rpAppLink.credits.offers()}
                                css={buttonStyle}
                                variant="filled_primary"
                                dataTestId={CREDIT_PAGES_IDS.MAIN_PAGE.COMPARE_CREDITS_OFFERS_BUTTON}
                            >
                                Porównaj oferty kredytowe
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>
    );
};

const bodyCopy = css`
    margin: 4rem 0;
    ${onDesktop(css`
        margin: 0;
    `)};
`;

const infoSectionStyle = css`
    margin-bottom: 0;

    ${onDesktop(css`
        margin: 65px auto -110px auto;
    `)};
`;

const contentPositioner = (theme: Theme) => css`
    ${w100};
    ${h100};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(8)};
    transform: translateY(-15%);

    @media (min-width: ${theme.breakpoints.md}) {
        transform: translateY(-40%);
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        gap: ${calculateRemSize(10)};
        transform: translateY(-50%);
    }
`;

const boxesWrapper = css`
    ${w100};
    gap: ${calculateRemSize(2)};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};

    ${onDesktop(css`
        gap: ${calculateRemSize(4)};
        ${flexDirection("row")};
    `)};
`;

const boxStyle = (theme: Theme) => css`
    ${w100};
    ${borderRadius(2)};
    ${elevation(2)};
    ${flex("center", "space-around")};
    ${p(3, 1)};
    ${flexDirection("column")};

    @media (min-width: ${theme.breakpoints.md}) {
        ${w50};
        ${p(3, 8)};
        height: 450px;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
        height: 368px;
    }
`;

const buttonStyle = (theme: Theme) => css`
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${resetWidth}
    }
`;
